module.exports = "/assets/data/c1990b727547274c5e14d72be3790d95-RG7.data.json";